import React, { useState } from 'react';
import {
    Box, Typography, Card, CardContent, Grid, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Button, Chip,
    TextField, MenuItem, InputAdornment, Dialog, DialogTitle,
    DialogContent, DialogActions, Tabs, Tab, Avatar, Divider
} from '@mui/material';
import {
    Search as SearchIcon, Download as DownloadIcon, Print as PrintIcon,
    Visibility as ViewIcon, School as SchoolIcon
} from '@mui/icons-material';
import { studentAPI } from '../services/api';

const StudentReport = () => {
    const [classFilter, setClassFilter] = useState('');
    const [sectionFilter, setSectionFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [reportType, setReportType] = useState('detailed');
    const [viewDialog, setViewDialog] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);

    const students = [
        { id: 1, admNo: 'ADM001', name: 'Aarav Patil', class: 'Class 10A', rollNo: 1, dob: '2010-05-15', gender: 'Male', category: 'OPEN', fatherName: 'Rajesh Patil', motherName: 'Sunita Patil', phone: '9876543210', address: 'Supe, Baramati', attendance: 92, fees: 'Paid', grade: 'A', remark: 'Excellent' },
        { id: 2, admNo: 'ADM002', name: 'Sneha Sharma', class: 'Class 10A', rollNo: 2, dob: '2010-08-22', gender: 'Female', category: 'OBC', fatherName: 'Amit Sharma', motherName: 'Priya Sharma', phone: '9876543211', address: 'Baramati', attendance: 88, fees: 'Partial', grade: 'B+', remark: 'Good' },
        { id: 3, admNo: 'ADM003', name: 'Rohan Kulkarni', class: 'Class 9B', rollNo: 1, dob: '2011-03-10', gender: 'Male', category: 'OPEN', fatherName: 'Suresh Kulkarni', motherName: 'Meena Kulkarni', phone: '9876543212', address: 'Indapur', attendance: 78, fees: 'Unpaid', grade: 'B', remark: 'Can improve' },
        { id: 4, admNo: 'ADM004', name: 'Priya Desai', class: 'Class 8A', rollNo: 1, dob: '2012-11-05', gender: 'Female', category: 'SC', fatherName: 'Mahesh Desai', motherName: 'Kavita Desai', phone: '9876543213', address: 'Daund', attendance: 95, fees: 'Paid', grade: 'A+', remark: 'Outstanding' },
        { id: 5, admNo: 'ADM005', name: 'Amit Singh', class: 'Class 7A', rollNo: 1, dob: '2013-01-20', gender: 'Male', category: 'OPEN', fatherName: 'Deepak Singh', motherName: 'Rekha Singh', phone: '9876543214', address: 'Phaltan', attendance: 85, fees: 'Partial', grade: 'B', remark: 'Average' },
        { id: 6, admNo: 'ADM006', name: 'Diya Wagh', class: 'Class 10A', rollNo: 3, dob: '2010-07-30', gender: 'Female', category: 'NT', fatherName: 'Sachin Wagh', motherName: 'Anita Wagh', phone: '9876543215', address: 'Baramati', attendance: 91, fees: 'Paid', grade: 'A', remark: 'Very Good' },
    ];

    const filteredStudents = students.filter(s => {
        const matchClass = !classFilter || s.class === classFilter;
        const matchSearch = !searchTerm || s.name.toLowerCase().includes(searchTerm.toLowerCase()) || s.admNo.toLowerCase().includes(searchTerm.toLowerCase());
        return matchClass && matchSearch;
    });

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h5" fontWeight={700}>Student Report</Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button variant="outlined" startIcon={<PrintIcon />} size="small">Print Report</Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />} size="small">Excel</Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />} size="small">PDF</Button>
                </Box>
            </Box>

            <Card sx={{ mb: 3 }}>
                <CardContent sx={{ p: '12px !important' }}>
                    <Grid container spacing={1.5} alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <TextField fullWidth select size="small" label="Report Type" value={reportType} onChange={(e) => setReportType(e.target.value)}>
                                <MenuItem value="detailed">Detailed Report</MenuItem>
                                <MenuItem value="attendance">Attendance Report</MenuItem>
                                <MenuItem value="fee">Fee Report</MenuItem>
                                <MenuItem value="academic">Academic Report</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <TextField fullWidth select size="small" label="Class" value={classFilter} onChange={(e) => setClassFilter(e.target.value)}>
                                <MenuItem value="">All Classes</MenuItem>
                                {[...new Set(students.map(s => s.class))].map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <TextField fullWidth size="small" placeholder="Search by name or adm no..." value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Card>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 700 }}>Roll</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Adm No.</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Student Name</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Class</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Gender</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Father's Name</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>Attendance</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Fees</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Grade</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredStudents.map(s => (
                                <TableRow key={s.id} hover>
                                    <TableCell>{s.rollNo}</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>{s.admNo}</TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Avatar sx={{ width: 24, height: 24, fontSize: 10, bgcolor: s.gender === 'Male' ? '#2196f3' : '#e91e63' }}>{s.name[0]}</Avatar>
                                            {s.name}
                                        </Box>
                                    </TableCell>
                                    <TableCell>{s.class}</TableCell>
                                    <TableCell>{s.gender}</TableCell>
                                    <TableCell><Chip label={s.category} size="small" variant="outlined" /></TableCell>
                                    <TableCell>{s.fatherName}</TableCell>
                                    <TableCell align="center">
                                        <Chip size="small" label={`${s.attendance}%`}
                                            color={s.attendance >= 90 ? 'success' : s.attendance >= 75 ? 'warning' : 'error'} />
                                    </TableCell>
                                    <TableCell>
                                        <Chip size="small" label={s.fees}
                                            color={s.fees === 'Paid' ? 'success' : s.fees === 'Partial' ? 'warning' : 'error'} />
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>{s.grade}</TableCell>
                                    <TableCell>
                                        <Button variant="outlined" size="small" startIcon={<ViewIcon />}
                                            onClick={() => { setSelectedStudent(s); setViewDialog(true); }}>View</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>

            {/* Student Detail Dialog */}
            <Dialog open={viewDialog} onClose={() => setViewDialog(false)} maxWidth="md" fullWidth>
                <DialogTitle>Student Report — {selectedStudent?.name}</DialogTitle>
                <DialogContent>
                    {selectedStudent && (
                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            <Grid item xs={12} sx={{ textAlign: 'center', mb: 1 }}>
                                <Avatar sx={{ width: 56, height: 56, mx: 'auto', bgcolor: selectedStudent.gender === 'Male' ? '#2196f3' : '#e91e63', fontSize: 22 }}>{selectedStudent.name[0]}</Avatar>
                                <Typography variant="h6" fontWeight={700} sx={{ mt: 1 }}>{selectedStudent.name}</Typography>
                                <Typography variant="body2" color="text.secondary">{selectedStudent.class} | Roll No: {selectedStudent.rollNo}</Typography>
                            </Grid>
                            <Grid item xs={12}><Divider><Typography variant="caption" color="text.secondary">Personal Info</Typography></Divider></Grid>
                            {[['Adm No.', selectedStudent.admNo], ['DOB', new Date(selectedStudent.dob).toLocaleDateString()], ['Gender', selectedStudent.gender], ['Category', selectedStudent.category]].map(([l, v]) =>
                                <Grid item xs={6} sm={3} key={l}><Typography variant="body2" color="text.secondary">{l}</Typography><Typography fontWeight={600}>{v}</Typography></Grid>
                            )}
                            <Grid item xs={12}><Divider><Typography variant="caption" color="text.secondary">Family Info</Typography></Divider></Grid>
                            {[["Father's Name", selectedStudent.fatherName], ["Mother's Name", selectedStudent.motherName], ['Phone', selectedStudent.phone], ['Address', selectedStudent.address]].map(([l, v]) =>
                                <Grid item xs={6} key={l}><Typography variant="body2" color="text.secondary">{l}</Typography><Typography fontWeight={600}>{v}</Typography></Grid>
                            )}
                            <Grid item xs={12}><Divider><Typography variant="caption" color="text.secondary">Academic Info</Typography></Divider></Grid>
                            {[['Attendance', `${selectedStudent.attendance}%`], ['Fee Status', selectedStudent.fees], ['Grade', selectedStudent.grade], ['Remark', selectedStudent.remark]].map(([l, v]) =>
                                <Grid item xs={6} sm={3} key={l}><Typography variant="body2" color="text.secondary">{l}</Typography><Typography fontWeight={600}>{v}</Typography></Grid>
                            )}
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setViewDialog(false)}>Close</Button>
                    <Button variant="outlined" startIcon={<PrintIcon />}>Print</Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />}>Download PDF</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default StudentReport;
